var map = {
	"./admin.svg": 843,
	"./agency.svg": 844,
	"./basics.svg": 845,
	"./ceshi.svg": 846,
	"./course_mall.svg": 847,
	"./enterprise.svg": 848,
	"./exam.svg": 849,
	"./exit.svg": 850,
	"./finance.svg": 851,
	"./help.svg": 852,
	"./inform.svg": 853,
	"./mall.svg": 854,
	"./message-solid.svg": 855,
	"./online-service.svg": 856,
	"./open-course.svg": 857,
	"./record.svg": 858,
	"./shop-home.svg": 859,
	"./shop.svg": 860,
	"./student.svg": 861,
	"./system_setup.svg": 862,
	"./trainer.svg": 863
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 907
// module chunks = 289